import { styled } from "@mui/system";

export const DialogContentContainer = styled('div') ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});

export const DialogInputContainer = styled('div') ({
    rowGap: 2,
    marginTop: '1em',
    display: 'flex',
    flexDirection: 'column'
});

export const InputSection = styled('div') ({
    border: '1px solid #d5d5d5ff',
    borderRadius: '20px',
    padding: '1em',
    marginBottom: '1em'
})

export const InputFieldContainer = styled('div') ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
    marginBottom: '1em',
    columnGap: '1em'
})

export const ValidatedInputFieldContainer  = styled('div') ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: '1em',
    columnGap: '1em'
})

export const ImageDropContainer = styled('fieldset') ({
    marginTop: '1em',

    [`& .dz-gallery`]:  {
        padding: '20px 0',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    ['& div.dz-image']: {
        position: 'relative',
        width: '50%',
        height: '100%',
        objectFit: 'cover',
        overflow: 'hidden',
    },
    [`& div.dz-image img`]: {    
        width: '100%',
        height: '100%',
        float: 'left',
        cursor: 'pointer',
        margin: '1em',
    },
    [`& div.dz-image > span`]: {
        display: 'none',
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        alignItems: 'center',
    },
    ['& div.dz-image:hover > span']: {
        display: 'flex'
    },
    [`& div.dz-image > span button`]: {
        margin: '0 auto !important',
        padding: '5px 10px !important',
        borderRadius: '9px',
        border: '1px solid #6d6d6d',
        background: '#fff',
    }
})
